import { render, staticRenderFns } from "./About375.vue?vue&type=template&id=98071288&scoped=true"
import script from "./About375.vue?vue&type=script&lang=js"
export * from "./About375.vue?vue&type=script&lang=js"
import style0 from "./About375.vue?vue&type=style&index=0&id=98071288&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98071288",
  null
  
)

export default component.exports